export enum EMaintenanceMode {
  YES = 'yes',
  NO = 'no',
}
